import {
  AppBar,
  Toolbar,
  IconButton,
  Box
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import logo from "../assets/logo.png"; // ✅ Updated import

function Header() {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        top: 0,
        zIndex: 1201,
        backgroundColor: "rgba(255, 255, 255, 0)",
        boxShadow: "none",
        backdropFilter: "blur(21px)",
        px: 2,
        py: 1,
      }}
    >
      <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
        
        {/* ✅ Updated logo section */}
        <Box
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => window.location.reload()}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ height: 40, width: "auto" }}
          />
        </Box>

        <Box>
          <IconButton>
            <AccountCircleIcon sx={{ fontSize: 40, color: "#1C2758" }} />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
